export const setActiveChannel = (data) => ({
    type: "CHANNEL_UPDATE",
    payload: {
        activeChannelId: data,
    },
});
